export default __webpack_public_path__ + "media/zurb/img/events/wired/second-harvest/harvest-img3-548f0e77aad22b7171d11d2073c3e083.jpg";